import axios from 'axios'
import { useMutation } from 'react-query'
import { FnSetSession, IRBACResponseOfLogin } from '../type'
import { URL_BASE_RBAC } from '../config'
import { addAuthorizationHeader } from './base'

type LoginPayloadType = {
  email: string;
  password: string;
}

const login = (payload:LoginPayloadType) => axios.post(
  `${URL_BASE_RBAC}/api/auth/login`,
  {
    ...payload,
  }
)

export const useRBACLogin = (setSession?: FnSetSession) => useMutation(
  login,
  {
    onSuccess(res:any) {
      // console.log('onSuccess', res)
      const result: IRBACResponseOfLogin = res?.data
      // console.log(result)
      if (
        !!result?.status &&
        (result.code === 200) &&
        !!result?.data &&
        !!result?.tokens?.access?.token
      ) {
        if (!!result?.tokens) {
          localStorage.setItem('rbac-session', JSON.stringify(result.tokens))
          addAuthorizationHeader({
            token_type: 'Bearer',
            access_token: result.tokens.access.token
          })
          setSession?.({
            tokens: result?.tokens
          })
        }
      }
    },
  }
)
